export default function cssifyMediaQueryRules(mediaQuery, mediaQueryRules) {
  if (mediaQueryRules) {
    return '@media ' + mediaQuery + '{' + mediaQueryRules + '}';
  }

  return '';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-tools/es/cssifyMediaQueryRules.js
// module id = 722
// module chunks = 0